// extracted by mini-css-extract-plugin
export default {"annotationToolbar":"PdfAnnotationSettings_annotationToolbar__1kp6V"};